import odata from 'odata-client';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import { showNotification } from '../notification';

var updateEntity = {

  tokenExpired: context => () => ({
    type: context.TOKEN_EXPIRED
  }),
  updateEntityRequest: context => () => ({
    type: context.UPDATE_ENTITY_REQUEST
  }),
  updateEntityError: context => errorOrResult => ({
    type: context.UPDATE_ENTITY_ERROR,
    error: errorOrResult.message
  }),
  updateEntitySuccess: context => payload => ({
    type: context.UPDATE_ENTITY_SUCCESS,
    payload
  }),

  init: context => {
    context.UPDATE_ENTITY_REQUEST = null;
    context.UPDATE_ENTITY_ERROR = null;
    context.UPDATE_ENTITY_SUCCESS = null;
    context.TOKEN_EXPIRED = null;
    context.entityName = null;
    context.entityLocation = null;
  },

  execute: context => (entity, entityTableData) => async (dispatch, getState) => {
    if (context.entityName === "crew") {
      if (!(entity.Name) || entity.Name.trim() === "" || !(entity.Organisation.ID)) {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }
    if (context.entityName === "specialday") {
      if (!(entity.Name) || entity.Name.trim() === "" || !(entity.Organisation.ID) || !(entity.DateFrom) || !(entity.DateTo)) {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }
    if (context.entityName === "driver") {
      if (!(entity.Name) || entity.Name.trim() === "" || !(entity.Organisation.ID)) {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }
    if (context.entityName === "mixingPlant") {
      if (!(entity.Name) || entity.Name.trim() === "" || !(entity.Organisation.ID)) {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }
    if (context.entityName === "mixtureOrder") {
      if (!(entity.OrderNumber) || entity.OrderNumber.trim() === "") {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }
    if (context.entityName === "mixture") {
      if (!(entity.Name) || entity.Name.trim() === "") {
        dispatch(showNotification("Required fields must NOT be empty", "error"))
        return new Error()
      }
    }

    dispatch(context.updateEntityRequest(context)());

    let patchObj = entity

    if (context.entityName === "driver") {
      patchObj = {
        ...patchObj,
        Organisation: { ID: patchObj.Organisation.ID }
      }
      if (patchObj.DefaultCrew && patchObj.DefaultCrew.ID && patchObj.DriverCompany && patchObj.DriverCompany.ID) {
        patchObj = { ...patchObj, DefaultCrew: { ID: patchObj.DefaultCrew.ID }, DriverCompany: { ID: patchObj.DriverCompany.ID } }
      }
    }
    if (context.entityName === "specialday") {
      patchObj = { ...patchObj, Organisation: { ID: patchObj.Organisation.ID } }
    }
    if (context.entityName === "crew") {
      patchObj = { ...patchObj, Organisation: { ID: patchObj.Organisation.ID } }
    }
    if (context.entityName === "mixingPlant") {
      patchObj = { ...patchObj, Organisation: { ID: patchObj.Organisation.ID } }
    }
    if (context.entityName === "project") {
      patchObj = {
        ...patchObj,
        Organisation: { ID: patchObj.Organisation.ID },
        Customer: { ID: patchObj.Customer.ID },
        Supervisor: { ID: patchObj.Supervisor.ID }
      }
    }
    if (context.entityName === "company") {
      patchObj = { ...patchObj, Organisation: { ID: patchObj.Organisation.ID } }
    }
    const query = odata({ service: getServiceUrl() }).resource(context.entityLocation, entity.ID);
    const errorOrResult = await query.patch(patchObj, {
      headers: {
        Authorization: `Bearer ${getState().user.token}`,
        ...getDefaultHeader()
      }
    })
      .then(res => {
        const ok = res.statusCode <= 299 && res.statusCode >= 200;
        if (res.statusCode === 500) {
          const errorKey = "GENERAL_SERVER_ERROR";
          return new Error(errorKey);
        } else if (!ok) {
          const response = res.toJSON()
          const error = JSON.parse(response.body).Error
          const errorKey = res.statusCode === 401 ? `401: ${error.Message}` : context.entityLocation === "ProjectActivities" ? error.Code :  `${error.Message}`;
          console.log(`update ${context.entityName} api error`, response);
          return new Error(errorKey);
        } else {
          const payload = entity;
          payload.tableData = entityTableData;
          return payload;
        }
      }, res => {
        // error
        const errorKey = `Error: ${res.status}, ${res.statusText}`;
        console.log('export project tender document api error', res.responseText);
        return new Error(errorKey);
      })
      .catch((error) => {
        console.error('Error:', error);
        dispatch(showNotification("Request probably timed out.", "error"))
      });

    if (errorOrResult instanceof Error) {
      dispatch(context.updateEntityError(context)(context.UPDATE_ENTITY_ERROR, errorOrResult.message));
      if (errorOrResult.message.split(":")[0] === "401") {
        dispatch(context.tokenExpired(context)());
        dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
      }
      console.log("CODE ERROR: ", errorOrResult.message);
      if (errorOrResult.message.includes(","))
        dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
      else
        dispatch(showNotification(errorOrResult.message, "error"))
      return errorOrResult;
    } else {
      dispatch(showNotification("SUCCESSFUL_SAVE", "success"))
    }

    dispatch(context.updateEntitySuccess(context)(errorOrResult));

    return errorOrResult;
  }
};

export default updateEntity;  
